// Shared rendering for a RolloutState — used by Features list + detail.
import type { RolloutState } from "@release-hub/shared";
import { cn } from "./cn";

const KIND_TO_CLASS: Record<RolloutState["kind"], string> = {
  ga: "bg-ga-soft text-ga",
  ea: "bg-ea-soft text-ea",
  in_development: "bg-nightly-soft text-nightly",
  unreleased: "bg-nightly-soft text-nightly",
  disabled: "bg-border text-text-tertiary",
};

export function RolloutBadge({
  rollout,
  size = "sm",
}: {
  rollout: RolloutState;
  size?: "sm" | "md";
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full font-semibold uppercase tracking-wider",
        size === "sm" ? "px-2 py-0.5 text-[10.5px]" : "px-2.5 py-1 text-xs",
        KIND_TO_CLASS[rollout.kind],
      )}
    >
      {rollout.label}
    </span>
  );
}
